import { gql } from 'graphql.macro';

export const addPanNumberTemplate = gql`
    mutation addPanNumber($value: String!, $description: String) {
        addPanNumber(value: $value, description: $description) {
            _id
            value
            description
        }
    }
`;

export const updatePanNumberTemplate = gql`
    mutation updatePanNumber($panNumberId: MongoDbObjectId!, $value: String!, $description: String) {
        updatePanNumber(panNumberId: $panNumberId, value: $value, description: $description) {
            _id
            value
            description
        }
    }
`;

export const deletePanNumberTemplate = gql`
    mutation deletePanNumber($panNumberId: MongoDbObjectId!) {
        deletePanNumber(panNumberId: $panNumberId) {
            _id
            value
        }
    }
`;

export const togglePanNumberFeatureTemplate = gql`
    mutation togglePanNumberFeature($isEnabled: Boolean!) {
        togglePanNumberFeature(isEnabled: $isEnabled)
    }
`;
